import { render, staticRenderFns } from "./FormBuilderColumns.vue?vue&type=template&id=65abd546&scoped=true&lang=pug&"
import script from "./FormBuilderColumns.vue?vue&type=script&lang=js&"
export * from "./FormBuilderColumns.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderColumns.vue?vue&type=style&index=0&id=65abd546&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abd546",
  null
  
)

/* custom blocks */
import block0 from "./FormBuilderColumns.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports